<template>
    <div class="menu-footer">
        <div class="row">
            <div v-if="isUserLogined" style="text-align:center" class="col-4"> <div class="router-a"><router-link to="/info" title="پروفایل"><i class="now-ui-icons users_single-02"></i></router-link></div></div>
            <div v-if="!isUserLogined" style="text-align:center" class="col-4"> <div class="router-a"><router-link to="/login" title="ورود"><i class="now-ui-icons users_single-02"></i></router-link></div></div>
            <div style="text-align:center" class="col-4">
                <div class="router-a">
                    <router-link to="/cart" title="سبد خرید">
                        <i class="now-ui-icons shopping_cart-simple"></i>
                    </router-link>
                    <span v-if="cart != null" class="countItem">{{  cart.CartInfo.CartDetailsCount }} </span>
                </div>
            </div>
            <div style="text-align:center" class="col-4"><div class="router-a"> <router-link to="/" title="صفحه اصلی"><i class="now-ui-icons shopping_shop"></i></router-link></div></div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                isUserLogined: ''
            }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            }
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
    }
</script>

<style scoped>
    .router-a {
        display:inline-block;
        position:relative;
    }
    .countItem {
        position: absolute;
        right: -18px;
        top: -14px;
        background-color: #ea5d5d;
        padding: 5px;
        border-radius: 20px;
        width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
    }
    .menu-footer {
        padding-top: 16px;
        position: fixed;
        overflow: hidden;
        bottom: 0;
        width: 100%;
        height: 50px;
        z-index: 999999;
      /*  background-color: #a5cd39;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#4aa0d0), to(#a5cd39));
        background-image: linear-gradient(#b8e343, #a5cd39);*/
        display: none;
    }

        .menu-footer .router-a {
            display: inline-block;
        }

            .menu-footer .router-a i {
/*                color: #fff;*/
                font-size: 17px;
            }

    @media only screen and (min-width: 0px) and (max-width: 1077px) {
        .menu-footer {
            display: block !important;
        }
    }
</style>